/* Copyright (c) 2026 Xperi. All Rights Reserved. */

// Use 'export type' for interfaces and types
export type { TOverlayOptionValue, TOverlayOptions } from "./TOverlayOptions";

// Re-export the OnePass domain type through the model boundary so consumers
// (viewModel, views) never reach into the data layer directly.
export type { OptionType } from "@tivocorp/data-domain-lib/client-code/onepass";

// Use 'export' for classes, enums, and constants
export { DynamicOptionsEngine } from "./DynamicOptionsEngine";
